import { render } from "./MarginLeft.vue?vue&type=template&id=6c5a9f0c&scoped=true&ts=true"
import script from "./MarginLeft.vue?vue&type=script&lang=ts"
export * from "./MarginLeft.vue?vue&type=script&lang=ts"

import "./MarginLeft.vue?vue&type=style&index=0&id=6c5a9f0c&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5a9f0c"]])

export default __exports__